import MonitoredBy from './MonitoredBy';

export default MonitoredBy;
